/**
 * Firestore collection name constants.
 * Single source of truth — prevents typos and simplifies future renames.
 */
export const COLLECTIONS = {
    USER: 'user',
    GARAGE: 'garage',
    VEHICLE: 'vehicle',
    VEHICLE_SERVICE: 'vehicle_service',
    VEHICLE_TRANSFER: 'vehicle_transfer',
    VEHICLE_ODOMETER_HISTORY: 'vehicle_odometer_history',
    FILE: 'file',
    SETTING_LIST_ITEM: 'setting_list_item',
    NOTIFICATION: 'notification',
    AUDIT_LOG: 'audit_log',
} as const
